import { Inject } from '@angular/core';

import {BehaviorSubject, Observable} from 'rxjs';
import { DOCUMENT } from '@angular/common';
import { environment } from '../../../environments/environment';

export class ModalService {
  private display: string;

  constructor(@Inject(DOCUMENT) private document: any,){

  }


  openModal() {
    this.display = 'open';
  }

  closeModal() {
    this.display = 'close';
    console.log("VALOR DISPLAY ES " + this.display);
  }

  setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    const expires = 'expires=' + d.toUTCString();
    this.document.cookie = cname + '=' + cvalue + ';'
      + expires + ';path=/;'
      // necessari per badalona, dins d'un iframe
      // SameSite=None necessita Secure
      // https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Set-Cookie/SameSite
      + (window.isSecureContext ? "SameSite=None;Secure;": "");
  }

  getCookie(cname): string {
    const name = cname + '=';
    const ca = this.document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return '';
  }
}


// WEBPACK FOOTER //
// /usr/nexus/jenkins/workspace/enmapa-geoportal-frontend/src/app/services/modal/modal.service.ts